import { TOUR_STEPS } from "./tourManifest";
import { resetAllTours, resetTour } from "./tourStorage";

export { default as OnboardingTour } from "./OnboardingTour";
export { TOUR_STEPS } from "./tourManifest";
export { resetTour, resetAllTours, hasSeenTour } from "./tourStorage";

// Not a Joyride tour (no steps, no target elements) — Parkhi's one-line
// greeting, shown via his own speech bubble in CammyDock.jsx, which imports
// this same constant rather than a second hardcoded copy. Kept out of
// TOUR_STEPS since that holds real step arrays for the old design's popover
// tours; this just needs a key resetOnboardingForNewSession can re-arm.
export const PARKHI_INTRO_TOUR_KEY = "parkhi-intro";

// Re-arms every tour (plus Parkhi's intro) so onboarding replays on next
// login. Demo-mode default — swap for a no-op (or a one-time-only check)
// once the real trigger frequency is decided. Only reached from an actual
// login (_storeSession in authService.js) — initializeAuth()'s session
// restore on a page refresh never calls this, so refreshing an already
// logged-in session does not replay anything.
export function resetOnboardingForNewSession() {
  resetAllTours(Object.keys(TOUR_STEPS));
  resetTour(PARKHI_INTRO_TOUR_KEY);
}
